import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { DataList } from '../common'
import { fetchUsers, modifyUsers, modifyUser } from './userAPI'
import type { User, UserState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  openModalReducer,
  closeModalReducer,
  setSearchConditionReducer,
  dismissErrorReducer,
  buildExtraReducers
} from './userReducer'

const initialState: UserState = {
  sort: { column: 'id', order: 'desc' },
  selectedIds: [],
  searchCondition: { includeDisabled: false },
  openedModal: null,
  ...DataList.initialState,
  data: [] as User[],
  errors: {}
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn as (state: UserState, action: PayloadAction<string>) => void,
    selectPage: DataList.selectPage as (state: UserState, action: PayloadAction<number>) => void,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    setSearchCondition: setSearchConditionReducer,
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) => buildExtraReducers(builder, { fetchUsers, modifyUsers, modifyUser })
})

export const {
  selectColumn,
  selectPage,
  selectId,
  unselectId,
  openModal,
  closeModal,
  setSearchCondition,
  dismissError
} = userSlice.actions
